import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaCreateAutogiroFile = () => {
  const { t } = useTranslation();
  const requiredMessage = t('common:validationMessages.required');
  const fileSchema = yup.object().shape({
    ownerId: yup.number().required(requiredMessage),
    autogiroMandates: yup.array().of(yup.number().required()).required(),
  });

  return fileSchema;
};
